// extracted by mini-css-extract-plugin
module.exports = {"copyright":"copyright-module--copyright--30hm1","madeBy":"copyright-module--madeBy--3pRlQ","icon":"copyright-module--icon--2Dt6_"};